import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { ServicejobSearchResultComponent } from './servicejob-search-result.component';
import { DataListModule } from '../data-list/data-list.module';

@NgModule({
    imports: [CommonModule, IonicModule, SharedModule, DataListModule],
    declarations: [ServicejobSearchResultComponent],
    exports: [ServicejobSearchResultComponent]
})
export class ServicejobSearchResultModule {}
